import { Box, Container, Typography } from '@mui/material'
import { DataGrid, GridColDef, GridRowsProp } from '@mui/x-data-grid'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { showUserRegistrations } from '../../../../../../redux/actions/users'
import { IRootState } from '../../../../../../redux/types'

interface IRegistrationsList {
  id: number
  type: string
  seminar: string
  lesson: string
  date: string
}

function UserRegistrations({ userId }: { userId: number | null }) {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()
  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { inscriptions } = useSelector((state: IRootState) => state.user)

  useEffect(() => {
    if (authUser !== null && userId) {
      dispatch(showUserRegistrations({ user_id: userId }))
    }
  }, [authUser])

  const rows: GridRowsProp<IRegistrationsList> =
    inscriptions.map((inscription: any, index: number) => {
      return { ...inscription, id: index }
    }) ?? []
  const columns: GridColDef[] = [
    { headerName: t('type'), field: 'type', flex: 1 },
    { headerName: t('seminar'), field: 'seminar', flex: 1 },
    { headerName: t('lesson'), field: 'lesson', flex: 1 },
    { headerName: t('date'), field: 'date', flex: 1 }
  ]

  return (
    <Container className="noPadding">
      <Typography variant="subtitle1" color="textSecondary">
        Inscripciones
      </Typography>
      <Box mt={2} height="400px">
        <DataGrid rows={rows} columns={columns} disableColumnMenu />
      </Box>
    </Container>
  )
}

export default UserRegistrations
